import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  useCreateTwoFactorEnablementMutation,
  useCreateTwoFactorProvisioningMutation,
} from 'components/hooks/twoFactorMutations';
import useOneTimePassword from 'components/hooks/useOneTimePassword';
import useValidationErrors from 'components/hooks/useValidationErrors';

import { useBreadBoard } from 'components/contexts/Toaster';
import EnableModal from 'components/settings/profile/twoFactorAuthentication/EnableModal';

import SkipModal from './SkipModal';

export default function EnforcedSetup({ afterSetupPath, canUserSkip }) {
  const breadBoard = useBreadBoard();
  const oneTimePasswordProps = useOneTimePassword();
  const validationErrorsProps = useValidationErrors({});
  const [skipModalOpen, setSkipModalOpen] = useState(false);

  const { t: i18nTAuthentication } = useTranslation('common', {
    keyPrefix: 'authentication',
  });

  const createProvisioningMutation = useCreateTwoFactorProvisioningMutation();
  const createEnablementMutation = useCreateTwoFactorEnablementMutation();

  const provisioningUri =
    createProvisioningMutation.data?.data?.attributes?.uri || '';

  useEffect(() => {
    createProvisioningMutation.mutate(
      {},
      {
        onError: breadBoard.addInedibleToast,
      },
    );
  }, []);

  const handleFormSubmit = (otpCode) => {
    createEnablementMutation.mutate(
      { otpAttempt: otpCode.join('') },
      {
        onSuccess: () => {
          window.location.assign(afterSetupPath);
        },
        onError: () => {
          oneTimePasswordProps.handleCleanupField();
          validationErrorsProps.handleValidationErrorsAssignment({
            otp_attempt: [
              i18nTAuthentication('errors.incorrectVerificationCode'),
            ],
          });
        },
      },
    );
  };

  return (
    <div>
      {canUserSkip && (
        <a
          className='tw-fixed tw-right-6 tw-top-6 tw-z-[100000] tw-cursor-pointer tw-text-white'
          onClick={() => setSkipModalOpen(true)}
        >
          {i18nTAuthentication('skipOnce')}
        </a>
      )}
      <EnableModal
        closeModal={() => {}}
        isDismissible={false}
        isOpen={!skipModalOpen}
        onFormSubmit={handleFormSubmit}
        oneTimePasswordProps={oneTimePasswordProps}
        provisioningUri={provisioningUri}
        validationErrorsProps={validationErrorsProps}
      />
      {canUserSkip && (
        <SkipModal
          afterSetupPath={afterSetupPath}
          closeModal={() => setSkipModalOpen(false)}
          isOpen={skipModalOpen}
        />
      )}
    </div>
  );
}

EnforcedSetup.propTypes = {
  afterSetupPath: PropTypes.string.isRequired,
  canUserSkip: PropTypes.bool.isRequired,
};
